export interface IDatePartModel {
  name: string;
  value: number;
}
